var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76.78 75.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#Namnl\xF6s_\xF6vertoning_102);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_102",
    "data-name": "Namnl\\xF6s \\xF6vertoning 102",
    cx: 40.36,
    cy: 36.57,
    fx: 40.36,
    fy: 36.57,
    r: 40.7,
    gradientTransform: "translate(-5.14 5.16) rotate(-8.49) scale(1 1.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f26f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hidden_star",
    "data-name": "Hidden star"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m31.43,28.89v-2.55l-1.49-8.06.21-7.21L25.28,1.31s2.33,1.27,2.97,1.27,4.88,3.61,4.88,3.61l3.4,4.46,1.7,2.97,2.55,4.67s2.33,7.64,2.97,7.21,5.52-4.03,5.52-4.03l5.73-2.12,7.43-2.12,6.58-.21,4.46,1.49-4.24,1.91-6.58,4.03-4.46,3.82-2.97,3.82-1.06,4.46,6.58,5.94,5.31,5.94,1.49,5.31-1.06,7.21-4.67-5.73-4.46-3.4-7-3.82-4.67-1.27-4.46,8.06-4.88,10.19-1.91,6.37-2.55-6.58-1.06-6.79.42-7,1.49-8.28-6.58-1.7-5.09-.42-10.4-.64s-10.4,2.55-9.12,1.27c1.27-1.27,7.43-6.37,7.43-6.37l8.49-3.82,6.58-1.27,5.31.21,2.12-1.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.16,
    cy: 30.62,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 48.77,
    cy: 32.01,
    r: 1.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.41,
    cy: 36.24,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.34,
    cy: 26.2,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.01,
    cy: 41.65,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.47,
    cy: 45.08,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.57,
    cy: 40.13,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.2,
    cy: 34.91,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.86,
    cy: 38.65,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.15,
    cy: 34.54,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 42.23,
    cy: 29.04,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.27,
    cy: 21.01,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 55.5,
    cy: 23.69,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.49,
    cy: 47.99,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.63,
    cy: 50.62,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.09,
    cy: 36.48,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.47,
    cy: 41.79,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.79,
    cy: 34.54,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.17,
    cy: 43.48,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.3,
    cy: 34.42,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.43,
    cy: 35.27,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.08,
    cy: 23.91,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.63,
    cy: 17.03,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.75,
    cy: 43.73,
    r: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.37,18.5c-.47-.17-.97-.27-1.47-.37-.53-.11-1.22-.01-1.56-.32-.93-.84-2.06-1.07-3.18-1.35-.6-.15-1.22-.35-1.82-.35-.96,0-1.97.37-2.87.18-1.31-.28-2.53-.1-3.79.12-.7.13-1.35.21-2.04.56-1.06.54-2.31.78-3.51.94-1.61.22-3.23.27-4.53,1.45-.24.22-.64.25-.93.42-1.09.62-2.19,1.23-3.25,1.9-.94.59-1.83,1.26-2.76,1.88-.13.09-.46.11-.53.03-.41-.46-.85-.92-1.12-1.46-.44-.89-.7-1.87-1.13-2.76-.83-1.72-1.7-3.42-2.59-5.1-.49-.93-1.22-1.77-1.57-2.74-.72-1.99-2.08-3.58-3.49-4.93-2.3-2.2-5-3.98-7.56-5.92-.61-.46-1.31-.97-2.1-.47-.55.35-.32,1.33.28,2.35,1.19,2.03,2.7,3.94,2.73,6.47,0,.13.1.26.16.39.46,1.13.87,2.28,1.4,3.38.75,1.55-.01,3.15.3,4.73.19.98-.12,2.05-.12,3.08,0,2.03.59,3.93,1.18,5.85.57,1.87.33,2.34-1.46,2.28-.26,0-.55-.04-.77.06-1.1.52-2.18.32-3.27.01-.46-.13-.93-.23-1.27-.31-.47.06-.79.08-1.09.16-1.02.25-2.06.46-3.05.79-2.04.66-4.13,1.23-6.06,2.12-2.06.96-3.98,2.24-5.94,3.41-.6.36-1.14.82-1.72,1.23-.27.2-.56.38-.84.57-.6.43-1.21.84-1.78,1.31-.36.3-.61.73-.95,1.06-.72.68-1.52,1.3-2.19,2.03-.18.2-.14.78.02,1.05.21.35.62.48,1.11.24.37-.17.84-.11,1.26-.17.19-.03.38-.07.57-.12.9-.24,1.79-.61,2.71-.71,2.21-.25,4.43-.4,6.64-.55,1.28-.09,2.58-.23,3.86-.12,2.36.19,4.7.53,7.05.83,1.02.13,2.04.29,3.03.54,1.15.28,2.27.68,3.4,1.03.49.15,1.16.15,1.4.48.21.28-.08.93-.12,1.41-.18,1.94-.36,3.88-.5,5.83-.07.9,0,1.81-.1,2.7-.11,1.04-.51,2.09-.43,3.1.08.97-.49,1.97.14,2.9.07.1,0,.29.02.43.13.96.19,1.94.4,2.89.4,1.77.84,3.54,1.34,5.28.59,2.01,1.25,4,1.92,5.99.49,1.46,2.12,1.21,2.83.18.11-.16.17-.52.07-.65-.7-.96-.55-2.04-.48-3.09.08-1.23.12-2.47.38-3.67.25-1.14.75-2.22,1.16-3.32.08-.21.24-.39.34-.6.71-1.54,1.39-3.09,2.12-4.62.56-1.18,1.17-2.34,1.78-3.5.39-.75.79-1.5,1.23-2.23.6-1,1.23-1.99,1.89-2.95.29-.42.66-1.05,1.04-1.08,1.25-.09,2.64-.27,3.74.18,1.2.49,2.64.66,3.58,1.75.06.07.23.04.32.09.88.44,1.8.81,2.63,1.34,2.01,1.29,3.44,3.3,5.67,4.38,1.28.62,2.14,1.98,2.47,3.46.24,1.06.24,2.17.41,3.24.05.33.27.89.44.9.37.02.94-.14,1.08-.42.44-.82.81-1.7,1.02-2.6.24-1.05.06-2.23.45-3.19.36-.91.44-1.76.45-2.67,0-.75.12-1.53-.03-2.25-.34-1.69-.69-3.41-1.27-5.03-.32-.9-1.2-1.51-1.95-2.19-1.51-1.37-2.67-3.11-4.04-4.64-.6-.67-1.26-1.38-2.04-1.8-1.38-.73-2.58-1.63-3.75-2.67-.59-.52-.64-.96-.28-1.44.78-1.02.87-2.55,2.28-3.12.16-.06.25-.37.32-.59.64-1.98,2.05-3.4,3.59-4.65,1.63-1.32,3.34-2.56,5.07-3.75,1.98-1.35,4.11-2.48,6.52-2.72,1.15-.12,2.14-.98,3.37-.62.11.03.43-.39.5-.65.04-.13-.22-.45-.41-.51Zm-6.17.42c-1.41.47-2.44,1.55-3.68,2.28-.6.35-1.32.51-1.88.9-1.47,1.03-2.91,2.12-4.32,3.23-1.14.9-2.41,1.72-3.28,2.84-.83,1.07-2.14,1.7-2.57,3.21l-1.51,5.8c1.51,1.05,2.99,2.14,4.48,3.21.18.13.33.3.48.45.55.57,1.12,1.11,1.63,1.72.73.87,1.42,1.78,2.11,2.69.9,1.19,1.73,2.44,2.7,3.57.87,1.02,1.79,1.87,1.91,3.4.08,1.07.07,2.15.21,3.17.12.95.38,1.61-.57,2.19-.14.09-.07.54-.09.8-.86-1.16-1.65-2.31-2.53-3.39-.26-.32-.77-.41-1.11-.69-.41-.33-.76-.73-1.13-1.11-.16-.16-.24-.42-.43-.53-1.96-1.22-3.89-2.5-5.92-3.6-1.96-1.07-4.03-1.94-6.05-2.92-.9-.44-1.79-.93-2.67-1.41-.53-.29-.84-.05-1,.42-.33.99-.67,1.98-.93,2.98-.4,1.53-1.26,2.81-2.22,4.01-.97,1.21-1.48,2.65-2.18,3.99-.68,1.3-.99,2.82-1.76,4.05-.66,1.05-.85,2.35-1.92,3.23-.53.44-.69,1.39-.89,2.14-.32,1.18-.53,2.39-.94,3.62-.62-2.17-1.31-4.32-1.84-6.51-.27-1.13-.2-2.33-.34-3.5-.11-.91-.36-1.8-.42-2.71-.04-.65-.04-1.41.25-1.97,1.07-2.06.39-4.28.75-6.39.08-.47.28-.92.41-1.38.39-1.32.79-2.64,1.16-3.96.05-.2.02-.59-.07-.62-.53-.18-.81-.87-1.5-.72-.13.03-.33,0-.41-.08-.72-.76-1.65-.53-2.53-.62-1.19-.12-2.37-.34-3.56-.52-1.1-.17-2.19-.43-3.3-.49-1.15-.06-2.31.12-3.46.08-.74-.03-1.46-.34-2.2-.39-.59-.05-1.19.13-1.79.14-1.08.03-2.16.02-3.24.01-1.78,0-3.55,0-5.33-.04-.6-.01-1.19-.13-1.86-.21.7-1.13,1.56-2,2.83-2.41.19-.06.38-.15.53-.29,1.18-1.11,2.67-1.59,4.14-2.15,1.32-.51,2.55-1.24,3.86-1.77,1.02-.41,2.21-.47,3.14-1.01,1.25-.73,2.66-.53,3.93-.99.36-.13.84.12,1.26.13,1.14.02,2.28,0,3.42,0,.94,0,1.88-.05,2.81,0,1.56.09,2.49-1.4,2.03-2.81-.67-2.05-1.18-4.17-1.56-6.29-.25-1.4-.21-2.86-.21-4.29,0-1.38.31-2.79.11-4.14-.31-2.08-.57-4.18-1.99-5.99-1.05-1.34-1.63-3.03-2.52-4.76.39.2.62.28.8.42,1.52,1.17,3.02,2.38,4.57,3.51.71.51,1.2,1.09,1.47,1.93.38,1.22,1.1,2.22,2.02,3.13.85.84,1.54,1.84,2.32,2.75.36.43.83.78,1.12,1.24.83,1.31,1.13,2.78,1.34,4.32.2,1.44.68,2.87,1.18,4.25.41,1.13,1.01,2.2,1.54,3.29.31.64.79.65,1.24.21.51-.5.9-1.12,1.4-1.63.81-.83,1.63-1.65,2.5-2.41.67-.59,1.39-1.11,2.13-1.61.81-.55,1.64-.99,2.71-.9,1.43.13,2.49-.85,3.65-1.46,1.77-.94,3.74-1.11,5.66-1.46,1.21-.22,2.43-.48,3.64-.47,1.26.01,2.53.31,3.79.52.42.07.8.46,1.26,0,.09-.1.48.09.72.31-.51.14-1.02.25-1.52.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.18,34.64c-.12-.15-.22-.33-.33-.49-1.48-2.21-3.57-2.97-6.12-2.43-.98.21-1.89.73-2.86,1.01-1.29.37-2.15,1.27-2.36,2.46-.3,1.66-.62,3.35-.1,5.08.2.66.53.88,1.08,1.01.69.16,1.43.23,2.05.54,1.06.52,2.17.63,3.27.48,1.65-.23,3.11-.87,4-2.42.37-.65.8-1.26,1.14-1.92.15-.29.14-.66.18-1,.07-.63.13-1.26.19-1.89.08-.02.15-.04.23-.06-.13-.12-.26-.23-.37-.36Zm-3.24,3.99c-.49.28-.78.91-1.2,1.34-.7.74-1.54,1.2-2.59,1.11-.21-.02-.43-.1-.63-.19-.36-.15-.7-.37-1.07-.49-1.24-.4-1.53-1.59-.69-2.61.25-.31.38-.76.45-1.16.32-1.89,2.08-3.58,3.73-3.53,1.8.05,3.01,1.5,3.01,3.34,0,.96-.07,1.67-1.01,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.73,23.15c.34,1.22.81,2.41,1.24,3.61.04.12.19.21.3.3.63.54,1.01-.05,1.45-.33-.27-.78-.51-1.51-.77-2.24-.63-1.79-1.27-3.58-1.9-5.37-.28-.8-.48-1.64-.88-2.37-.61-1.11-1.35-2.15-2.07-3.19-.61-.88-1.11-1.9-2.29-2.3.03.28-.02.55.09.72.48.71.96,1.42,1.52,2.07,1.01,1.17,1.59,2.57,2.04,3.99.53,1.67.8,3.42,1.27,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.39,32.91c1.06.01,2.13.08,3.17-.03,2.07-.22,4.13-.54,6.45-.85-.19-.22-.37-.59-.52-.58-1.8.09-3.6.2-5.4.39-1.01.11-2.01.46-3.02.53-2.37.14-4.59.8-6.74,1.75-.63.28-1.28.51-1.87.85-.69.39-1.32.88-1.98,1.33.07.11.13.23.2.34.85-.37,1.71-.71,2.55-1.1,1.05-.5,2.08-1.05,3.14-1.55.38-.18.87-.17,1.19-.4.87-.64,1.83-.69,2.83-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.28,21.24c.9-.38,1.72-.92,2.57-1.41.05-.03.04-.15.1-.38-5.32,1.37-10.02,3.61-13.79,7.73.16.24.34.52.55.85.61-.41,1.22-.71,1.66-1.16.81-.83,1.43-1.86,2.3-2.62,1.11-.98,2.27-1.95,3.85-2.21.94-.15,1.88-.44,2.75-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.24,36.9c-.26.11-.62-.07-.93-.05-.82.04-1.64.1-2.45.16-.01.15-.02.3-.03.45.51.08,1.02.19,1.53.22,1.59.09,3.18-.39,4.77.06,1.1.31,2.23.5,3.34.78,1.25.32,2.5.68,3.82,1.04.14-.35.32-.79.48-1.18-2.07-.39-3.96-.73-5.84-1.11-1.55-.31-3.05-1.04-4.68-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.25,26.16c.04-.14-.19-.34-.26-.53-.39-.95-.94-1.87-1.11-2.85-.33-1.88-.44-3.79-.64-5.69-.03-.01-.06-.03-.1-.04-.06.21-.15.41-.16.62-.07,1.1-.12,2.19-.18,3.29-.02.36-.06.71-.08,1.07-.12,1.76.74,3.27,1.28,4.86.09.26.5.42.76.62.17-.45.38-.89.5-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.29,44.83c-.75.72-1.43,1.38-2.14,2.06.28.1.49.18.63.24-1.18,2.26-2.34,4.47-3.49,6.68.08.08.17.15.25.23.34-.35.74-.66,1.01-1.06.42-.61.72-1.29,1.12-1.9.47-.71,1.12-1.33,1.46-2.09.35-.78.35-1.71,1.18-2.25.25-.16.47-.43.6-.69.07-.14-.04-.4-.12-.58-.08-.18-.24-.31-.5-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.85,43.8c.34.3.64.7,1.03.89.95.47,1.97.81,2.92,1.28,2.83,1.39,6.03,2.15,8.16,4.75.13.16.41.19.62.29-3.41-3.84-8.08-5.45-12.44-7.59-.1.13-.2.25-.3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.35,40.04c1.73.92,3.58,1.67,4.79,3.35.28.39.64.74,1.02,1.05.35.29.77.5,1.16.74-1.98-2.75-4.14-5.22-7.38-6.52-.43.47-.31,1,.41,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.53,51.15c.02,2.59-.35,5.08.43,7.5.13-.01.25-.02.38-.03.06-1.05.13-2.11.17-3.16.03-.93-.07-1.88.06-2.8.1-.75-.2-1.12-1.03-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.6,26.75c-.64.57-1.05,1.38-1.57,2.09.1.05.19.09.29.14,1.84-1.12,6.84-5.94,6.9-6.74-.38.29-.73.53-1.05.79-1.53,1.23-3.1,2.41-4.57,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35,44.25c-.25-.03-.5,0-.74,0-.22,2.12-.44,4.15-.65,6.18.05.02.1.03.15.05.33-.55.66-1.09,1.01-1.67-.22-.17-.39-.31-.63-.49.45-1.12.86-2.19,1.32-3.24.24-.54.05-.76-.46-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.45,22.04l.17.34c.62-.34,1.23-.67,1.85-1.01-.07-.12-.13-.23-.2-.35-.61.34-1.22.68-1.83,1.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSea);
export default __webpack_public_path__ + "static/media/star-sea.12720ef6a24a224d48a60e29cdcf7f73.svg";
export { ForwardRef as ReactComponent };